<template>
  <form class="contact-form" id="email_signup" :class="embedClass" data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe" action="//manage.kmail-lists.com/subscriptions/subscribe" method="GET" target="_blank" accept-charset="UTF-8" _lpchecked="1" @submit="showMessaging">
    <input type="hidden" name="form_type" value="customer"/>
    <input type="hidden" name="g" :value="listId"/>
    <transition name="slideOut">
      <div class="newsletter-form-inner-container" :class="inputClass" v-if="!isSuccess || notSubmitted">
        <input class="newsletter-input" type="email" name="email" id="k_id_email" value="" :placeholder="placeholderText" autocorrect="off" autocapitalize="off" autocomplete="email" v-model="emailInput" required="required" aria-label="Email"/>
        <button class="newsletter-submit-container klaviyo_submit_button" type="submit" id="Subscribe" :class="buttonClass" :aria-label="buttonText.length ? buttonText : 'Submit'">
          <icon name="arrow_long_right" size="30px"></icon>
        </button>
      </div>
    </transition>
    <transition name="slideIn">
      <p class="newsletter-form-success" v-if="isSuccess && successMessage">{{ successMessage }}</p>
    </transition>
  </form>
</template>

<script>
import Icon from '../basic/Icon.vue';
export default {
  name: 'KlaviyoForm',
  components: {
    Icon,
  },
  data () {
    return {
      isSuccess: false,
      notSubmitted: true,
      emailInput: ''
    }
  },
  props: {
    successMessage: {
      type: String,
      default: 'Thank you for signing up!'
    },
    message: String,
    listId: String,
    inputClass: String,
    buttonClass: String,
    buttonText: String,
    sendEvent: String,
    event: String,
    customProps: Object,
    placeholderText: {
      type: String,
      default: 'email@example.com'
    }
  },
  methods: {
    showMessaging: function () {
      this.$store.dispatch('email/addEmail', this.emailInput)
      if (this.sendEvent === 'true') {
        setTimeout(() => {
          this.$emit(this.event)
        }, 1000)
      }
      this.notSubmitted = false
      setTimeout(() => {
        this.isSuccess = true
      }, 500)
    }
  },
  computed: {
    embedClass () {
      return 'klaviyo_embed_' + this.listId
    }
  },
  mounted () {
    const interval = setInterval(() => {
      if (KlaviyoSubscribe) {
        KlaviyoSubscribe.attachToForms(this.$el, {
          hide_form_on_success: false,
          extra_properties: typeof this.customProps !== 'undefined' ? this.customProps : {},
          custom_success_message: true
        })
        clearInterval(interval)
      }
    }, 1000)
  }
}
</script>

<style scoped lang="scss">
  .newsletter-form-inner-container {
    position: relative;
    border-bottom: 1px solid #F0EAD4;

    &:hover {
      border-color: #F0EAD4;
    }
  }

  .klaviyo_submit_button {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    padding: 0 17px;
    min-width: 0;
    width: auto;
  }

  .newsletter-input {
    padding: 12px 0;
    color: $color-white;

    &:-webkit-autofill,
    &:-internal-autofill-previewed {
      transition: background-color 5000s ease-in-out 0s;
      -webkit-text-fill-color: #fff !important;
    }

    &::placeholder {
      color: inherit;
    }
  }
  
</style>
